import { createContext, useContext } from 'react';

const facilityValue: any = {};

export const FacilityContext = createContext(facilityValue);
export const useFacilityContext = () => useContext(FacilityContext);
